import { Component, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { KpiWidgetComponent } from '../../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { PartsAndInventoryService } from '../../../services/parts-and-inventory.service';
import { PartsKpiRequest } from '../../../models/parts-kpi.model';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-low-stock-widget',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './low-stock-widget.component.html',
  styleUrls: ['./low-stock-widget.component.scss']
})
export class LowStockWidgetComponent extends BaseWidgetComponent {
  private partsAndInventoryService = inject(PartsAndInventoryService);
  private errorService = inject(ErrorHandlerService);
  private transloco = inject(TranslocoService);

  public errorMessage: string = '';
  public hasError: boolean = false;

  override title = this.transloco.translate('parts.widgets.lowStock');
  override isLoading = true;
  override value = 0;

  constructor() {
    super(inject(FilterService));
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    await this.loadLowStockParts();
  }

  private async loadLowStockParts(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';

    const request: PartsKpiRequest = {
      accountIds: this.widgetFilter.accountIds
    };

    try {
      this.cancelSubject.next();
      const response = await this.partsAndInventoryService.getLowStockPartsAsync(request);

      this.value = response.data?.totalValue ?? 0;
    } catch (error) {
      this.errorService.handleError(error);
    } finally {
      this.isLoading = false;
    }
  }

  public override formatValue(value: number): string {
    return `${value.toFixed(0)}`;
  }

  public openInventoryValueModal(): void { }
}